import { markdown } from "../../helpers/markdown";

interface MarkdownTranslationTypes {
  translation: string;
  styles?: string;
  options?: Record<PropertyKey, unknown>;
}

function MarkdownTranslation({
  translation,
  styles,
  options = {},
}: MarkdownTranslationTypes) {
  return (
    <div
      className={styles}
      dangerouslySetInnerHTML={{
        __html: markdown(I18n.t(translation, options)),
      }}
    />
  );
}

export default MarkdownTranslation;
